import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import NavBar from './components/NavBar';
import React, {useRef, useState} from 'react'
//pages
import PageNotFound from '../PageNotFound.js'
import Home from './Home';
import Register from './Register.js';
import Details from './Details.js';
import PrimaryStudentRegister from './PrimaryStudentRegister.js';

function App(props) {
    const [isExspand, setIsExspand] = useState(false)
  return (
    <div className="w-full flex full-viewport-height flex flex-col" style={{letterSpacing:1.05, overflow:'auto'}}>

      <NavBar isExspand={isExspand} setIsExspand={(val) => setIsExspand(val)}/>
      <Routes >
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/details" element={<Details />} />
        <Route path="/register" element={<Register />} />
        <Route path="/primary/register" element={<PrimaryStudentRegister />} />

        
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(App)

